import { create } from "zustand";

/** UI navigation only; opening review never grants approval or starts work. */
export const useReviewSheet = create<{
  scope: "chat" | "all" | null;
  open: (scope: "chat" | "all") => void;
  close: () => void;
}>(set => ({ scope: null, open: scope => set({ scope }), close: () => set({ scope: null }) }));
